import React, { useState, useEffect } from "react"
import { Card, CardBody } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import RoleBasedPermissionSelector from "./RoleBasedPermissionSelector"

const RolePermissionsImproved = ({
  permissions,
  loading,
  url,
  rightBtn,
  onChangePermission,
  permissionResponse,
  activePermissions,
  role,
  groupedPermissions,
}) => {
  const [selectedPermissions, setSelectedPermissions] = useState(
    activePermissions || []
  )

  useEffect(() => {
    if (activePermissions) {
      setSelectedPermissions(activePermissions)
    }
  }, [activePermissions])

  // Handle permission change from the GroupedPermissionSelector
  const handlePermissionChange = newPermissions => {
    const added = newPermissions.filter(p => !selectedPermissions.includes(p))
    const removed = selectedPermissions.filter(p => !newPermissions.includes(p))

    // Process added permissions
    added.forEach(permission => {
      onChangePermission(permission, "add")
    })

    // Process removed permissions
    removed.forEach(permission => {
      onChangePermission(permission, "delete")
    })

    setSelectedPermissions(newPermissions)
  }

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={permissionResponse?.loading || loading}
          title={`${role?.role?.name || "Role"} Permissions`}
          lgColumn={4}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={rightBtn ? true : false}
          rightBtnTitle={"Back"}
          rightBtnRoute={url && url}
        />

        <div className="mt-4">
          <RoleBasedPermissionSelector
            groupedPermissions={groupedPermissions}
            selectedPermissions={selectedPermissions}
            onChange={handlePermissionChange}
            disabledPermissions={[]}
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default RolePermissionsImproved
